import Response from '@/shared/types/response';
import User, { UserLogin } from '@/shared/types/user';
import fetcher from '@/shared/utils/fetcher';

const login = async (accountId: string, email: string, password: string) => {
  const apiKey = import.meta.env.VITE_API_VENDOR_KEY as string;
  const apiSecret = import.meta.env.VITE_API_VENDOR_SECRET as string;

  const body: UserLogin = {
    account_id: accountId,
    email_address: email,
    password,
    set_no_expiry: false,
  };

  try {
    return await fetcher<Response<User>, typeof body>({
      url: '/users/authenticate/',
      method: 'POST',
      body,
      headers: {
        'X-Wave-Api-Key': `bearer ${apiKey}`,
        'X-Wave-Api-Secret': apiSecret,
      },
    });
  } catch (error) {
    console.error(
      'Error occurred in function "login" in file "src/shared/api/auth/login.ts":',
      error,
    );
    return error as Response<User>;
  }
};

export default login;
